// ── 지도가 쓰는 마커 표시 설정 (2026-10-24) ─────────────────────────────────
// 처음엔 처음 값(= 지금 모양)으로 그리고, 테넌트 설정이 오면 그것으로 다시 그린다. 못 받아도 처음 값(지도가 멈추지 않게).
// 같은 화면의 ⚙️ 설정에서 저장하면 MARKER_CONFIG_EVENT 로 알려 와 바로 바뀐다(새로고침 없이).
import { useEffect, useState } from 'react';
import { apiClient } from '../../api/apiClient';
import { defaultMarkerConfig, normalizeMarkerConfig } from './markerConfig';

export const MARKER_CONFIG_EVENT = 'meeting-marker-config-saved';

export function useMarkerConfig() {
  const [config, setConfig] = useState(defaultMarkerConfig);
  useEffect(() => {
    let alive = true;
    apiClient.get('/api/tm/meeting-marker-config')
      .then((r) => { if (alive && r?.ok && r.data?.config) setConfig(normalizeMarkerConfig(r.data.config)); })
      .catch(() => {});
    const onSaved = (e) => { if (e?.detail) setConfig(normalizeMarkerConfig(e.detail)); };
    window.addEventListener(MARKER_CONFIG_EVENT, onSaved);
    return () => { alive = false; window.removeEventListener(MARKER_CONFIG_EVENT, onSaved); };
  }, []);
  return config;
}
